<div class="table-wrap">
  <table class="companies" [class.rows-enter]="!loading()">
    <thead>
      <tr>
        <th scope="col">Empresa</th>
        <th scope="col">Situação</th>
        <th scope="col" class="col-hide-sm">Natureza jurídica</th>
        <th scope="col" class="col-hide-sm">Último ato</th>
        <th scope="col" class="num">Sócios</th>
        <th scope="col" class="num col-hide-sm">Administradores</th>
      </tr>
    </thead>
    <tbody>
      @if (loading()) {
        @for (row of skeletonRows; track row) {
          <tr class="skel-row" aria-hidden="true">
            <td>
              <div class="skel-lines">
                <span class="skel-line" [style.width.%]="70 - (row % 3) * 12"></span>
                <span class="skel-line skel-line--sub"></span>
              </div>
            </td>
            <td><span class="skel-pill"></span></td>
            <td class="col-hide-sm"><span class="skel-line skel-line--mid"></span></td>
            <td class="col-hide-sm">
              <div class="skel-lines">
                <span class="skel-line skel-line--mid"></span>
                <span class="skel-line skel-line--sub"></span>
              </div>
            </td>
            <td class="num"><span class="skel-line skel-line--num"></span></td>
            <td class="num col-hide-sm"><span class="skel-line skel-line--num"></span></td>
          </tr>
        }
      } @else {
        @for (item of items(); track item.companyId) {
          <tr
            class="company-row"
            tabindex="0"
            [attr.aria-label]="'Abrir o Societário de ' + item.companyName"
            (click)="openCompany.emit(item.companyId)"
            (keydown.enter)="openCompany.emit(item.companyId)">
            <td>
              <div class="company">
                <span class="company__name" [title]="item.companyName">{{ item.companyName }}</span>
                <span class="company__cnpj">{{
                  item.cnpj ? formatCnpj(item.cnpj) : 'CNPJ não informado'
                }}</span>
              </div>
            </td>
            <td>
              @if (item.status === 'none') {
                <div class="none">
                  <app-charter-status-badge status="none" />
                  <button
                    type="button"
                    class="link-btn"
                    title="Abrir o Data Room da empresa para enviar o contrato social"
                    (click)="onSend($event, item.companyId)"
                    (keydown.enter)="$event.stopPropagation()">
                    <i class="pi pi-upload" aria-hidden="true"></i>Enviar contrato social
                  </button>
                </div>
              } @else {
                <app-charter-status-badge
                  [status]="item.status"
                  [pendingReviewCount]="item.pendingReviewCount" />
              }
            </td>
            <td class="col-hide-sm muted">
              {{ item.legalNature ? (natureLabel[item.legalNature] ?? item.legalNature) : '-' }}
            </td>
            <td class="col-hide-sm">
              @if (item.lastActLabel) {
                <div class="act">
                  <span class="act__label" [title]="item.lastActLabel">{{
                    item.lastActLabel
                  }}</span>
                  @if (item.lastActDate) {
                    <span class="act__date">{{ item.lastActDate | vaultDate }}</span>
                  }
                </div>
              } @else {
                <span class="muted">-</span>
              }
            </td>
            <td class="num">{{ countLabel(item.holdersCount) }}</td>
            <td class="num col-hide-sm">{{ countLabel(item.administratorsCount) }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
